import React, { Component } from 'react';

import { withTranslation } from 'react-i18next';
import Select from 'react-select';

class TriggerTypeSelector extends Component {
  render() {
    const { t, onChange, placeholder, value } = this.props;
    const options = [
      { value: 'scheduler', label: t('triggerType.scheduler') },
      { value: 'trigger', label: t('triggerType.trigger') },
      { value: 'listener', label: t('triggerType.listener') },
    ];
    return (
      <Select
        value={options.find((option) => option.value === value)}
        options={options}
        onChange={onChange}
        placeholder={placeholder}
        noOptionsMessage={() => t('noOptions')}
      />
    );
  }
}

export default withTranslation('translation')(TriggerTypeSelector);
